import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimAddTimelineEvent() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api
      .store(storeId)
      .shippingProtection.claim(`${shippingClaim.id}`).addTimelineEvent,
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      }),
  });
}
